import { SafeStorage } from "../storage/storage";
import { generateAnonymousId } from "./anonymous";
import { CookieOptions } from "../storage/cookie";
import { ThricoIdentifyParams } from "../core/types";

export class IdentityManager {
  private static ANON_KEY = "__thrico_anon_id";
  private static CUST_KEY = "__thrico_cust_id";
  private static EXT_KEY = "__thrico_ext_id";

  private anonymousId: string;
  private customerId: string | null = null;
  private externalId: string | null = null;
  private cookieOptions: CookieOptions;

  constructor(cookieOptions: CookieOptions = {}) {
    this.cookieOptions = cookieOptions;

    // Load or generate anonymous ID
    let anon = SafeStorage.getItem(IdentityManager.ANON_KEY);
    if (!anon) {
      anon = generateAnonymousId();
      SafeStorage.setItem(IdentityManager.ANON_KEY, anon, this.cookieOptions);
    }
    this.anonymousId = anon;

    // Load known customer ID if previously identified
    this.customerId = SafeStorage.getItem(IdentityManager.CUST_KEY);
    this.externalId = SafeStorage.getItem(IdentityManager.EXT_KEY);
  }

  public getAnonymousId(): string {
    return this.anonymousId;
  }

  public getCustomerId(): string | null {
    return this.customerId;
  }

  public getExternalId(): string | null {
    return this.externalId;
  }

  public identify(params: ThricoIdentifyParams): void {
    if (!params.customerId) return;

    this.customerId = params.customerId;
    SafeStorage.setItem(IdentityManager.CUST_KEY, params.customerId, this.cookieOptions);

    if (params.externalId) {
      this.externalId = params.externalId;
      SafeStorage.setItem(IdentityManager.EXT_KEY, params.externalId, this.cookieOptions);
    }
  }

  public reset(): void {
    SafeStorage.removeItem(IdentityManager.CUST_KEY, this.cookieOptions);
    SafeStorage.removeItem(IdentityManager.EXT_KEY, this.cookieOptions);
    this.customerId = null;
    this.externalId = null;

    // Generate new fresh anonymous ID
    this.anonymousId = generateAnonymousId();
    SafeStorage.setItem(IdentityManager.ANON_KEY, this.anonymousId, this.cookieOptions);
  }
}
